module.exports = __webpack_public_path__ + "img/wallMob.59a88ebd.jpg";